// locales/en.js
export default {
	"Prénom" : "Prénom" ,
	"Nom" : "Nom",
	"Courriel" : "Courriel",
	"Contacts" : "Contacts",
	"Factures" : "Factures",
	"Relevés" : "Relevés",
	"Relances" : "Relances",
	"Menu" : "Menu",
	"Personnes" : "Personnes",
	"Le prénom est obligatoire" :"Le prénom est obligatoire",
	"Mon compte" : "Mon compte",
	"Modifier" : "Modifier",
	"Déconnexion" : "Déconnexion",
	"Téléphone" : "Téléphone",
	"N°" : "N°",
	"Portable" : "Portable",
	"Connexion" : "Connexion",
	"Annuler" : "Annuler",
	"Mot de passe" : "Mot de passe",
	"Le mot de passe doit comprendre au moins 8 caractères, une majuscule, une minuscule et un chiffre" :
		"Le mot de passe doit comprendre au moins 8 caractères, une majuscule, une minuscule et un chiffre",
	"Demander un nouveau mot de passe":"Demander un nouveau mot de passe",
	"Renseignez votre adresse pour obtenir un lien pour définir un nouveau mot de passe.":
		"Renseignez votre adresse pour obtenir un lien pour définir un nouveau mot de passe.",
	"Enregistrer" : "Enregistrer",
	"<< Retour" : "<< Retour",
	"Association" : "Association",
	"Ajout de personne" : "Ajout de personne",
	"Créer" : "Créer",
	"Supprimer" : "Supprimer",
	"Utilisateurs de l'application":"Utilisateurs de l'application",
	"Libellé":"Libellé",
	"Description":"Description",
	"Aucune ligne n'est sélectionnée":"Aucune ligne n'est sélectionnée",
	"Clé":"Clé",
	"Admin":"Admin",
	"Editeur":"Editeur",
	"Lecteur":"Lecteur",
	"Ajouter":"Ajouter",
	"Droits d'accès des utilisateurs":"Droits d'accès des utilisateurs",
	"Sauvegarder":"Sauvegarder",
	"Restaurer":"Restaurer",
	"Mobile":"Mobile",
	"Profil":"Profil",
	"Actif":"Actif",
	"Jusqu'au":"Jusqu'au",
	"Langue":"Langue",
	"Dupliquer":"Dupliquer",
	"#":"#",
	"Journal de l'application":"Journal de l'application",
	"Type":"Type",
	"Fonction":"Fonction",
	"Libellés de l'application":"Libellés de l'application",
	"Famille":"Famille",
	"Code":"Code",
	"Nom du fichier":"Nom du fichier",
	"Date - heure":"Date - heure",
	"Taille":"Taille",
	"Message":"Message",
	"Date et heure":"Date et heure",
	"Niveau":"Niveau",
	"Module":"Module",
	"IP":"IP",
	"Détails":"Détails",
	"Identifiant":"Identifiant",
	"Mes informations":"Mes informations",
	"Nom court":"Nom court",
	"Code langue":"Code langue",
	"Connexions utilisateurs":"Connexions utilisateurs",
	"Utilisateur":"Utilisateur",
	"En ligne":"En ligne",
	"Dernière action":"Dernière action",
	"ou votre adresse e-mail" : "ou votre adresse e-mail",
	"L'identifiant ne peut être vide" : "L'identifiant ne peut être vide",
	"Le mot de passe ne peut être vide" : "Le mot de passe ne peut être vide",
	"Aide" : "Aide",
	"Paramètres de l'application":"Paramètres de l'application",
	"Valeur" : "Valeur",
	"Texte" : "Texte",
	"L'identifiant peut être utilisé à la place</br>du courriel pour se connecter":"L'identifiant peut être utilisé à la place</br>du courriel pour se connecter",
	"Cette adresse courriel n'est pas valide":"Cette adresse courriel n'est pas valide",
	"Confirmation" : "Confirmation",
	"Veuillez confirmer la suppression de cette fiche":"Veuillez confirmer la suppression de cette fiche",
	"OK" : "OK",
	"Aucun masque n'est sélectionnée" : "Aucun masque n'est sélectionnée",
	"Nouveau" : "Nouveau",
	"La modification n'est pas enregistrée sur le serveur." : "La modification n'est pas enregistrée sur le serveur.",
	"Sauvegarde en cours ..." : "Sauvegarde en cours ...",
	"Restauration en cours du fichier : " : "Restauration en cours du fichier : ",
	"Votre demande pour modifier votre mot de passe n'a pas abouti" : "Votre demande pour modifier votre mot de passe n'a pas abouti",
	"Vous allez recevoir un message avec un lien pour modifier votre mot de passe" : "Vous allez recevoir un message avec un lien pour modifier votre mot de passe",
	"Valider" : "Valider",
	"Connexion non valide" : "Connexion non valide",
	"Code client" : "Code client",
	"Nom usuel":"Nom usuel",
	"Adresse":"Adresse",
	"N° et rue":"N° et rue",
	"Code Postal":"Code Postal",
	"Ville":"Ville",
	"Pays":"Pays",
	"N° Siret":"N° Siret",
	"Règlement":"Règlement",
	"Notes":"Notes",
	"Fiche client":"Fiche client",
	"Mnémo":"Mnémo",
	"Liste des clients":"Liste des clients",
	"Fenêtre": "Fenêtre",
	"Dimension":"Dimension",
	"Professionnel" : "Professionnel",
	"Numéro TVA" : "Numéro TVA",
	"Comptabilité" : "Comptabilité",
	"Compte comptable" : "Compte comptable",
	"Recherche par nom ..." : "Recherche par nom ...",
	"Actualiser" : "Actualiser",
	"Préférences d'affichage" : "Préférences d'affichage",
	"Effacer toutes les préférences" : "Effacer toutes les préférences",
	"Les données ne sont pas enregistrées" : "Les données ne sont pas enregistrées",
	"Voulez-vous quitter tout de même ?" : "Voulez-vous quitter tout de même ?",
	"Informations de l'entreprise" : "Informations de l'entreprise",
	"Raison sociale" : "Raison sociale",
	"TVA 20%" : "TVA 20%",
	"TVA 10%" : "TVA 10%",
	"TVA 5,5%" : "TVA 5,5%",
	"TVA 2,1" : "TVA 2,1",
	"Pas de TVA" : "Pas de TVA",
	"L'adresse e-mail n'est pas valide" : "L'adresse e-mail n'est pas valide",
	"Note facture" : "Note facture",
	"Le code client est obligatoire" : "Le code client est obligatoire",
	"Tout condenser" : "Tout condenser",
	"Tout étirer" : "Tout étirer",
	"Recherche par libellé ..." : "Recherche par libellé ...",
	"Liste des produits" : "Liste des produits",
	"Nature" : "Nature",
	"Code produit" : "Code produit",
	"Désignation" : "Désignation",
	"Prix vente" : "Prix vente",
	"Prix de vente unitaire HT" : "Prix de vente unitaire HT",
	"Code TVA" : "Code TVA",
	"Interdit" : "Interdit",
	"Produit interdit à la vente" : "Produit interdit à la vente",
	"Prix d'achat" : "Prix d'achat",
	"Veuillez confirmer la suppression de toute la mise en forme de cette liste" : "Veuillez confirmer la suppression de toute la mise en forme de cette liste",
	"N° document" : "N° document",
	"Prix Vente" : "Prix Vente",
	"Remise" : "Remise",
	"Prix Net" : "Prix Net",
	"Quantité" : "Quantité",
	"N° ligne" : "N° ligne",
	"Total" : "Total",
	"Prix Net Net" : "Prix Net Net",
	"TVA" : "TVA",
	"Client" : "Client",
	"N° du compte comptable" : "N° du compte comptable",
	"Facture" : "Facture",
	"Lignes" : "Lignes",
	"" : "",
	"Chargement en cours ..." : "Chargement en cours ...",
	"Total TTC" : "Total TTC",
	"Total HT" : "Total HT",
	"Nom client" : "Nom client",
	"Date" : "Date",
	"Ouvrir" : "Ouvrir",
	"Factures non validées" : "Factures non validées",
	"Appeler fixe" : "Appeler fixe",
	"Appeler mobile" : "Appeler mobile",
	"Total TVA" : "Total TVA",
	"Total HT du document" : "Total HT du document",
	"Montant TVA" : "Montant TVA",
	"Taux TVA %" : "Taux TVA %",
	"Libellé TVA" : "Libellé TVA",
	"Année, mois et numéro" : "Année, mois et numéro",
	"Année et numéro" : "Année et numéro",
	"Numéro uniquement" : "Numéro uniquement",
	"Client livraison" : "Client livraison",
	"Immatériel" : "Immatériel",
	"Location" : "Location",
	"Assemblage" : "Assemblage",
	"Lot" : "Lot",
	"Commentaire" : "Commentaire",
	"Prestation" : "Prestation",
	"produit" : "produit",
	"TVA 2,1%" : "TVA 2,1%",
	"Abonnement" : "Abonnement",
	"Relevé de factures" : "Relevé de factures",
	"Groupe de documents" : "Groupe de documents",
	"Facture fournisseur" : "Facture fournisseur",
	"Avoir" : "Avoir",
	"Retour garantie" : "Retour garantie",
	"Ticket de caisse" : "Ticket de caisse",
	"Bon de retour fournisseur" : "Bon de retour fournisseur",
	"Panier" : "Panier",
	"Bon de retour client" : "Bon de retour client",
	"Commande fournisseur" : "Commande fournisseur",
	"Bon de réception" : "Bon de réception",
	"Accusé de réception de commande" : "Accusé de réception de commande",
	"Bon de livraison" : "Bon de livraison",
	"Commande": "Commande",
	"Pro-forma" : "Pro-forma",
	"Devis" : "Devis",
	"Total TTC " : "Total TTC ",
	"Facture en Avoir" : "Facture en Avoir",
	"Autres options" : "Autres options",
	"Entête enregistrée" : "Entête enregistrée",
	"Lignes enregistrées" : "Lignes enregistrées",
	"Nouvelle facture" : "Nouvelle facture",
	"Quitter" : "Quitter",
	"Voulez-vous les enregistrer avant de quitter ?" : "Voulez-vous les enregistrer avant de quitter ?",
	"Masque" : "Masque",
	"Relire" : "Relire",
	"Mise en forme supprimée" : "Mise en forme supprimée",
	"Informations Factures / Devis" : "Informations Factures / Devis",
	"Retour" : "Retour",
	"Texte logo" : "Texte logo",
	"Texte de remplacement en cas d'absence de logo" : "Texte de remplacement en cas d'absence de logo",
	"Format N° de facture" : "Format N° de facture",
	"Ne modifiez plus ce format une fois que vous avez commencé à émettre des factures, voir l'aide" : "Ne modifiez plus ce format une fois que vous avez commencé à émettre des factures, voir l'aide",
	"Conditions de règlement" : "Conditions de règlement",
	"Mentions obligatoires" : "Mentions obligatoires",
	"Références bancaires" : "Références bancaires",
	"Dernier N° de facture utilisé" : "Dernier N° de facture utilisé",
	"ATTENTION, référez vous aux conseils de configuration pour modifier cette donnée" : "ATTENTION, référez vous aux conseils de configuration pour modifier cette donnée",
	"E-mail" : "E-mail",
	"Début exercice" : "Début exercice",
	"Fin exercice" : "Fin exercice",
	"Imprimer" : "Imprimer",
	"Factures chronologie" : "Factures chronologie",
	"Recherche désignation ..." : "Recherche désignation ...",
	"La date est obligatoire" : "La date est obligatoire",
	"Les données ne sont pas enregistrées." : "Les données ne sont pas enregistrées.",
	"Voulez-vous quitter quand même ?" : "Voulez-vous quitter quand même ?",
	"Oui" : "Oui",
	"Non" : "Non",
	"Avoir sur Facture N° " : "Avoir sur Facture N° ",
	"Trop de taux de TVA différents dans le même document" : "Trop de taux de TVA différents dans le même document",
	"Le montant HT de la facture est négatif. " : "Le montant HT de la facture est négatif. ",
	"Il est obligatoire de faire un avoir séparé." : "Il est obligatoire de faire un avoir séparé.",
	"Le montant HT de l'avoir est positif'. " : "Le montant HT de l'avoir est positif'. ",
	"Il est obligatoire de faire une facture." : "Il est obligatoire de faire une facture.",
	"Unid" : "Unid",
	"Initiales" : "Initiales",
	"Cette note sera ajoutée sur la facture du client." : "Cette note sera ajoutée sur la facture du client.",
	"Veuillez confirmer la suppression des fiches sélectionnées : " : "Veuillez confirmer la suppression des fiches sélectionnées : ",
	"Code prospect" : "Code prospect",
	"Générer pdf" : "Générer pdf",
	"Génération du fichier pdf en cours" : "Génération du fichier pdf en cours",
	"Transformer en Avoir" : "Transformer en Avoir",
	"Créer un Avoir" : "Créer un Avoir",
	"Un produit de type 'Commentaire' ne peut avoir de prix ou de code TVA" : "Un produit de type 'Commentaire' ne peut avoir de prix ou de code TVA",
	"Un produit ne peut avoir un prix d'achat négatif" : "Un produit ne peut avoir un prix d'achat négatif",
	"Un produit ne peut avoir un prix de vente négatif" : "Un produit ne peut avoir un prix de vente négatif",
	"Le prix de vente est inférieur au prix d'achat" : "Le prix de vente est inférieur au prix d'achat",
	"Ce code produit est déjà utilisé : " : "Ce code produit est déjà utilisé : ",
	"Liste clients" : "Liste clients",
	"1 ligne" : "1 ligne",
	"2 lignes" : "2 lignes",
	"3 lignes" : "3 lignes",
	"Format mode de règlement" : "Format mode de règlement",
	"Erreur d'enregistrement des données factures" : "Erreur d'enregistrement des données factures",
	"Mois de facturation" : "Mois de facturation",
	"Erreur d'enregistrement des données entreprise" : "Erreur d'enregistrement des données entreprise",
	"Veuillez confirmer la suppression de cette facture" : "Veuillez confirmer la suppression de cette facture",
	"Document supprimé" : "Document supprimé",
	"Erreur de suppression du document" : "Erreur de suppression du document",
	"Avoir en Facture" : "Avoir en Facture",
	"Ce document n'est pas une facture" : "Ce document n'est pas une facture",
	"Le total H.T. de cette facture est négatif, impossible de créer un avoir." : "Le total H.T. de cette facture est négatif, impossible de créer un avoir.",
	"Un avoir sur facture sera créé à partir de cette facture." : "Un avoir sur facture sera créé à partir de cette facture.",
	"Toutes les quantités positives deviendront négatives et réciproquement." : "Toutes les quantités positives deviendront négatives et réciproquement.",
	"L'indication du code TVA est obligatoire" : "L'indication du code TVA est obligatoire",
	"Ce produit est bloqué à la vente, code " : "Ce produit est bloqué à la vente, code ",
	"Un taux de remise ne peut être négatif" : "Un taux de remise ne peut être négatif",
	"Vous avez des erreurs dans les lignes, veuillez corriger pour valider" : "Vous avez des erreurs dans les lignes, veuillez corriger pour valider",
	"Erreur de déverrouillage du document" : "Erreur de déverrouillage du document",
	"Erreur d'enregistrement de l'entête" : "Erreur d'enregistrement de l'entête",
	"Veuillez confirmer la génération du fichier pdf" : "Veuillez confirmer la génération du fichier pdf",
	"Veuillez confirmer le retour au document enregistré" : "Veuillez confirmer le retour au document enregistré",
	"Veuillez confirmer l'annulation de la saisie du document'" : "Veuillez confirmer l'annulation de la saisie du document'",
	"Veuillez confirmer la suppression de ce document" : "Veuillez confirmer la suppression de ce document",
	"L'adresse e-mail n'est pas valide." : "L'adresse e-mail n'est pas valide.",
	"Le traitement de votre demande en cours ..." : "Le traitement de votre demande en cours ...",
	"L'application n'est pas disponible pour le motif : " : "L'application n'est pas disponible pour le motif : ",
	"La réouverture est prévue pour : " : "La réouverture est prévue pour : ",
	"Erreur d'enregistrement des données personnelles" : "Erreur d'enregistrement des données personnelles",
	"Erreur de verrouillage de la fiche" : "Erreur de verrouillage de la fiche",
	"Veuillez sélectionner l'enregistrement à modifier" : "Veuillez sélectionner l'enregistrement à modifier",
	"Supprimer les verrous" : "Supprimer les verrous",
	"Les verrous de cet utilisateur sont supprimés" : "Les verrous de cet utilisateur sont supprimés",
	"Liste des sauvegardes" : "Liste des sauvegardes",
	"Générer une facture" : "Générer une facture",
	"Générer un avoir" : "Générer un avoir",
	"Veuillez confirmer la suppression de cette ligne" : "Veuillez confirmer la suppression de cette ligne",
	"Le code produit est obligatoire" : "Le code produit est obligatoire",
	"Veuillez confirmer la suppression des lignes sélectionnées : " : "Veuillez confirmer la suppression des lignes sélectionnées : ",
	"Retour à l'accueil" : "Retour à l'accueil",
	"Données d'entreprise" : "Données d'entreprise",
	"Gérer mon compte" : "Gérer mon compte",
	"Assistance" : "Assistance",
	"Bloqué" : "Bloqué",
	"Produit bloqué à la vente" : "Produit bloqué à la vente",
	"Générer pdf depuis la liste" : "Générer pdf depuis la liste",
	"Liste produits" : "Liste produits",
	"Demande d'assistance" : "Demande d'assistance",
	"Demande le" : "Demande le",
	"Veuillez préciser votre demande" : "Veuillez préciser votre demande",
	"Fermer" : "Fermer",
	"Envoyer" : "Envoyer",
	"Type doc." : "Type doc.",
	"Créé le" : "Créé le",
	"Tiers" : "Tiers",
	"Liste des documents" : "Liste des documents",
	"Père" : "Père",
	"Droits Concepteur" : "Droits Concepteur",
	"Note document" : "Note document",
	"Brouillons de devis" : "Brouillons de devis",
	"Une facture sera créé à partir de ce document." : "Une facture sera créé à partir de ce document.",
	"Liste chronologique des devis" : "Liste chronologique des devis",
	"TTC" : "TTC",
	"Veuillez confirmer l'enregistrement de ce document dont le total HT est nul" : "Veuillez confirmer l'enregistrement de ce document dont le total HT est nul",
	"Demande de verrou" : "Demande de verrou",
	"Forcer le verrou" : "Forcer le verrou",
	"Article" : "Article",
	"Indiquez votre adresse e-mail dans le champ identifiant pour demander un nouveau mot de passe." : "Indiquez votre adresse e-mail dans le champ identifiant pour demander un nouveau mot de passe.",
	"Remise_%" : "Remise_%",    // Limité pour largeur de colonne
	"Le total TTC d'un document ne peut pas dépasser 100 millions d'Euros." : "Le total TTC d'un document ne peut pas dépasser 100 millions d'Euros.",
	"Dépassement de 100 millions d'Euros." : "Dépassement de 100 millions d'Euros.",
	"La remise doit être comprise entre 0 et 100%" : "La remise doit être comprise entre 0 et 100%",
	"Un produit ne peut pas avoir un prix de vente négatif" : "Un produit ne peut pas avoir un prix de vente négatif",
	"Id" : "Id",
	"Brouillons factures et avoirs" : "Brouillons factures et avoirs",
	"Totaux" : "Totaux",
	"Contrôle" : "Contrôle",
	"Compte vente" : "Compte vente",
	"Désignation compte" : "Désignation compte",
	"Nature des produits" : "Nature des produits" ,
	"Prestations" : "Prestations",
	"Total prestations" : "Total prestations",
	"Fournitures" : "Fournitures",
	"Total fournitures" :  "Total fournitures",
	"Certaines lignes ne sont ni Prestation, ni Fourniture." : " Certaines lignes ne sont ni Prestation, ni Fourniture.",
	" Veuillez corriger pour valider votre facture." : " Veuillez corriger pour valider votre facture.",
	"Le code nature est obligatoire" : "Le code nature est obligatoire",


};